import axios from 'axios'
import aesKey from './key'
import encryptor from './encryptor'
import userStore from '../store/module/user'
import sConfig from '@/config'

//创建axios的一个实例
const instance = axios.create({
  timeout: 6000
})
let mEncrypt = false
// 请求拦截器
instance.interceptors.request.use(config => {
  if (mEncrypt) {
    let key
    if (sConfig.app) {
      key = aesKey.pro
    } else {
      key = aesKey.dev
    }
    if (config.method.toLocaleLowerCase() === 'post' ||
      config.method.toLocaleLowerCase() === 'put' ||
      config.method.toLocaleLowerCase() === 'patch') {
      config.headers.post['Content-Type'] = 'application/json'
      config.headers.put['Content-Type'] = 'application/json'
      config.headers.patch['Content-Type'] = 'application/json'
      // eslint-disable-next-line no-console
      console.log('data before encrypt is ' + JSON.stringify(config.data))
      let mag = encryptor.encrypt(JSON.stringify(config.data), key.key, key.iv)
      let encryptData = {
        pid: key.pid,
        mag
      }
      config.data = JSON.stringify(encryptData)
    }
  }
  const userToken = userStore.state.token
  config.headers['userToken'] = userToken
  config.headers['token'] = userToken
  // eslint-disable-next-line no-console
  console.log('http request：' + JSON.stringify(config))
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})
//响应拦截器
instance.interceptors.response.use(response => {
  if (mEncrypt) {
    const { data: { mag: m } = {} } = response
    let mag = m
    if (!mag) {
      return Promise.reject(Error('解密失败'))
    }

    let key
    if (sConfig.app) {
      key = aesKey.pro
    } else {
      key = aesKey.dev
    }
    let decryptData = encryptor.decrypt(mag, key.key, key.iv)
    // eslint-disable-next-line no-console
    console.log('decryptData is ' + decryptData)
    if (!decryptData || Object.keys(decryptData).length === 0) {
      return Promise.reject(Error('解密失败'))
    }
    response.data = JSON.parse(decryptData)
  }
  return response.data
}, error => {
  // eslint-disable-next-line no-console
  console.log(JSON.stringify(error))
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default (method, url, data = null, encrypt = false) => {
  method = method.toLowerCase()
  mEncrypt = encrypt
  if (method === 'post') {
    return instance.post(url, data)
  } else if (method === 'get') {
    return instance.get(url, { params: data })
  } else if (method === 'delete') {
    return instance.delete(url, { params: data })
  } else if (method === 'put') {
    return instance.put(url, data)
  } else {
    // eslint-disable-next-line no-console
    console.error('未知的method' + method)
    return false
  }
}
